import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { dealApi, dealQueryKeys } from '@crm/entities/deal';
import { toastManager } from '@crm/entities/toast';
import { getApiErrorMessage } from '@crm/shared/api';

import type { TCreateDealCommentPayload, TDeal } from '@crm/entities/deal';

export const useCreateDealCommentMutation = ({ dealId }: { dealId: TDeal['id'] }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: dealQueryKeys.createComment(dealId),
        mutationFn: (payload: TCreateDealCommentPayload) =>
            dealApi.createDealComment({ dealId, payload }),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: dealQueryKeys.detail(dealId) });
        },
        onError: (error) => {
            toastManager.onError({
                title: getApiErrorMessage(
                    error,
                    t('crm.dealDetailsContent.notesBlock.errors.create')
                ),
            });
        },
    });
};
